<!--
 * @Description: 矿粉模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:05:02
-->
<template>
  <div id="template3" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="7"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg5: !isViewResult }">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg3: !isViewResult }">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_06 }}</td>
        <td>车 牌 号</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>材质证明</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>颜色对比</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          <el-select v-model="formData.cell_18.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_18.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>胶砂加水时间</td>
        <td class="bg3 select_date" colspan="8">
          <el-date-picker v-model="formData.cell_19.resultValue" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>试验期龄</td>
        <td colspan="4">3天</td>
        <td colspan="4">28天</td>
      </tr>
      <tr>
        <td>强度项目</td>
        <td colspan="2">强度</td>
        <td colspan="2">强度平均值</td>
        <td colspan="2">强度</td>
        <td colspan="2">强度平均值</td>
      </tr>
      <tr>
        <td rowspan="6">抗压强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_20.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }" rowspan="6" colspan="2">{{ formData.cell_26.resultValue }}</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg1: !isViewResult }" rowspan="6" colspan="2">{{ formData.cell_33.resultValue }}</td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_21.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_28.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_22.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_29.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_23.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_30.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_24.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_31.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_32.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>基准水泥</td>
        <td>7天强度（Mpa）</td>
        <td :class="{ bg5: !isViewResult }">
          {{ formData.cell_34.resultValue }}
        </td>
        <td colspan="2">28天强度（Mpa）</td>
        <td :class="{ bg5: !isViewResult }">
          {{ formData.cell_35.resultValue }}
        </td>
        <td>基准流动度（mm）</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ formData.cell_36.resultValue }}
        </td>
      </tr>
      <tr>
        <td rowspan="4">检测结果</td>
        <td>7天活性指数（%）</td>
        <td :class="formData.cell_37.clsObj">
          {{ formData.cell_37.resultValue }}
          <el-tooltip v-if="formData.cell_37.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_37.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td colspan="2">28天活性指数（%）</td>
        <td :class="formData.cell_38.clsObj">
          {{ formData.cell_38.resultValue }}
          <el-tooltip v-if="formData.cell_38.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_38.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>试样流动度（mm）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>密度（g/cm³）</td>
        <td :class="formData.cell_40_p04.clsObj" @click="setData('cell_40')">{{ formData.cell_40_p04.resultValue || "请配置" }}</td>
        <td colspan="2">比表面积（m²/kg）</td>
        <td :class="formData.cell_41.clsObj">
          <el-input v-model="formData.cell_41.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>流动度比（%）</td>
        <td :class="formData.cell_42.clsObj" colspan="2">
          {{ formData.cell_42.resultValue }}
          <el-tooltip v-if="formData.cell_42.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_42.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td>三氧化硫含量（%）</td>
        <td :class="formData.cell_43_p04.clsObj" @click="setData('cell_43')">{{ formData.cell_43_p04.resultValue || "请配置" }}</td>
        <td colspan="2">烧矢量（%）</td>
        <td :class="formData.cell_44_p04.clsObj" @click="setData('cell_44')">{{ formData.cell_44_p04.resultValue || "请配置" }}</td>
        <td>样品颜色对比</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-select v-model="formData.cell_45.resultValue" placeholder="请选择">
            <el-option :value="0" label="相邻批次一致"></el-option>
            <el-option :value="1" label="相邻批次不一致"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>氯离子含量（%）</td>
        <td :class="{ bg2: !isViewResult }" @click="setData('cell_46')">{{ formData.cell_46_p04.resultValue || "请配置" }}</td>
        <td colspan="2">含水量（%）</td>
        <td :class="formData.cell_47_p03.clsObj" @click="setData('cell_47')">{{ formData.cell_47_p03.resultValue || "请配置" }}</td>
        <td>是否含石粉</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-select v-model="formData.cell_48.resultValue" placeholder="请选择">
            <el-option :value="0" label="是"></el-option>
            <el-option :value="1" label="否"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td rowspan="2">备 注</td>
        <td rowspan="2" colspan="8">
          <el-input v-model="formData.cell_49.resultValue" type="textarea" :rows="2" :readonly="isViewResult" />
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <!--                    <el-select v-model="tester" filterable value-key="value" placeholder="请选择">-->
          <!--                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item"></el-option>-->
          <!--                    </el-select>-->
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_17: {
    resultValue: "",
    key: "kjczzm",
    title: "材质证明",
    category: 7,
    type: 1,
    code: 'cell_17',
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
  },
  cell_18: {
    resultValue: "",
    key: "kjysdb",
    title: "颜色对比",
    category: 7,
    type: 1,
    code: 'cell_18',
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
  },
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },
  cell_19: { resultValue: "", key: "jsjssj", title: "胶砂加水时间", category: 3, type: 3, code: "cell_19" },
  cell_20: { resultValue: "", key: "kyqd7_1", title: "抗压强度7天", category: 3, type: 3, code: "cell_20" },
  cell_21: { resultValue: "", key: "kyqd7_2", title: "抗压强度7天", category: 3, type: 3, code: "cell_21" },
  cell_22: { resultValue: "", key: "kyqd7_3", title: "抗压强度7天", category: 3, type: 3, code: "cell_22" },
  cell_23: { resultValue: "", key: "kyqd7_4", title: "抗压强度7天", category: 3, type: 3, code: "cell_23" },
  cell_24: { resultValue: "", key: "kyqd7_5", title: "抗压强度7天", category: 3, type: 3, code: "cell_24" },
  cell_25: { resultValue: "", key: "kyqd7_6", title: "抗压强度7天", category: 3, type: 3, code: "cell_25" },
  cell_27: { resultValue: "", key: "kyqd28_1", title: "抗压强度28天", category: 3, type: 3, code: "cell_27" },
  cell_28: { resultValue: "", key: "kyqd28_2", title: "抗压强度28天", category: 3, type: 3, code: "cell_28" },
  cell_29: { resultValue: "", key: "kyqd28_3", title: "抗压强度28天", category: 3, type: 3, code: "cell_29" },
  cell_30: { resultValue: "", key: "kyqd28_4", title: "抗压强度28天", category: 3, type: 3, code: "cell_30" },
  cell_31: { resultValue: "", key: "kyqd28_5", title: "抗压强度28天", category: 3, type: 3, code: "cell_31" },
  cell_32: { resultValue: "", key: "kyqd28_6", title: "抗压强度28天", category: 3, type: 3, code: "cell_32" },
  cell_34: { resultValue: "", key: "jzsnqd7", title: "基准水泥强度7天", category: 3, type: 1, code: "cell_34" },
  cell_35: { resultValue: "", key: "jzsnqd28", title: "基准水泥强度28天", category: 3, type: 1, code: "cell_35" },
  cell_36: { resultValue: "", key: "jzldd", title: "基准流动度", category: 3, type: 3, code: "cell_36" },
  cell_39: { resultValue: "", key: "syldd", title: "试样流动度", category: 3, type: 3, code: "cell_39" },
  cell_40_p01: { unit: "g", valType: "input", resultValue: "", key: "mdsyz", title: "试样重", category: 3, type: 3, code: "cell_40_p01" },
  cell_40_p02: { unit: "g", valType: "input", resultValue: "", key: "mddyckd", title: "第一次刻度", category: 3, type: 3, code: "cell_40_p02" },
  cell_40_p03: { unit: "g", valType: "input", resultValue: "", key: "mddeckd", title: "第二次刻度", category: 3, type: 3, code: "cell_40_p03" },
  cell_40_p04: { unit: "g", valType: "calc", resultValue: "", key: "md", title: "密度", category: 3, type: 3, code: "cell_40_p04", clsObj: { bg2: true } },
  cell_41: { resultValue: "", key: "bbmj", title: "比表面积", category: 3, type: 3, code: "cell_41", clsObj: { bg1: true } },
  cell_43_p01: { unit: "g", valType: "input", resultValue: "", key: "syhlkggz", title: "空坩埚重", category: 2, type: 3, code: "cell_43_p01" },
  cell_43_p02: { unit: "g", valType: "input", resultValue: "", key: "syhlsyz", title: "试样重", category: 2, type: 3, code: "cell_43_p02" },
  cell_43_p03: { unit: "g", valType: "input", resultValue: "", key: "syhlzshzz", title: "灼烧后总重", category: 2, type: 3, code: "cell_43_p03" },
  cell_43_p04: { unit: "g", valType: "calc", resultValue: "", key: "syhlhl", title: "三氧化硫含量", category: 2, type: 3, code: "cell_43_p04", clsObj: { bg2: true } },
  cell_44_p01: { unit: "g", valType: "input", resultValue: "", key: "sslsyz", title: "烧矢量试样重", category: 3, type: 3, code: "cell_44_p01" },
  cell_44_p02: { unit: "g", valType: "input", resultValue: "", key: "sslkggz", title: "烧矢量空坩埚重", category: 3, type: 3, code: "cell_44_p02" },
  cell_44_p03: { unit: "g", valType: "input", resultValue: "", key: "sslzshzz", title: "烧矢量灼烧后总重", category: 3, type: 3, code: "cell_44_p03" },
  cell_44_p04: { unit: "g", valType: "calc", resultValue: "", key: "ssl", title: "烧矢量", category: 3, type: 3, code: "cell_44_p04", clsObj: { bg2: true } },
  cell_45: { resultValue: "", key: "ypysdb", title: "样品颜色对比", category: 3, type: 3, code: "cell_45" },
  cell_46_p01: { unit: "g", valType: "input", resultValue: "", key: "llzhlkb", title: "空白试验消耗的硫氰酸铵标准滴定溶液体积", category: 3, type: 3, code: "cell_46_p01" },
  cell_46_p02: { unit: "g", valType: "input", resultValue: "", key: "llzhldd", title: "滴定时消耗的硫氰酸铵标准滴定溶液的体积", category: 3, type: 3, code: "cell_46_p02" },
  cell_46_p03: { unit: "g", valType: "input", resultValue: "", key: "llzhlsyz", title: "氯离子含量试样重", category: 3, type: 3, code: "cell_46_p03" },
  cell_46_p04: { unit: "g", valType: "calc", resultValue: "", key: "llzhl", title: "氯离子含量", category: 3, type: 3, code: "cell_46_p04" },
  cell_47_p01: { unit: "g", valType: "input", resultValue: "", key: "hgqsyzl", title: "烘干前试样质量", category: 3, type: 3, code: "cell_47_p01" },
  cell_47_p02: { unit: "g", valType: "input", resultValue: "", key: "hghsyzl", title: "烘干后试样质量", category: 3, type: 3, code: "cell_47_p02" },
  cell_47_p03: { unit: "g", valType: "calc", resultValue: "", key: "hsl", title: "含水量", category: 3, type: 3, code: "cell_47_p03", clsObj: { bg2: true } },
  cell_48: { resultValue: "", key: "sfhsf", title: "是否含石粉", category: 3, type: 3, code: "cell_48" },
  cell_49: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_49" },
  // 以下为计算属性
  cell_26: { resultValue: "", key: "kyqd7", title: "抗压强度7天", category: 1, type: 3, code: "cell_26" },
  cell_33: { resultValue: "", key: "kyqd28", title: "抗压强度28天", category: 1, type: 3, code: "cell_33" },
  cell_37: { resultValue: "", key: "hxzs7", title: "活性指数7天", category: 1, type: 3, code: "cell_37", clsObj: { bg1: true } },
  cell_38: { resultValue: "", key: "hxzs28", title: "活性指数28天", category: 1, type: 3, code: "cell_38", clsObj: { bg1: true } },
  cell_42: { resultValue: "", key: "lddb", title: "流动度比", category: 1, type: 3, code: "cell_42", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  watch: {
    defaultData(val) {
      if(val) {
        this.formData["cell_34"].resultValue = this.defaultData.sevenDayAvg;
        this.formData["cell_35"].resultValue = this.defaultData.twentyEightDayAvg;
        this.formData["cell_36"].resultValue = this.defaultData.referenceMobility;
      }
    }
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
  },
  mounted() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (!item) {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    //基准水泥强度取最近一条胶砂数据
    this.formData["cell_34"].resultValue = this.defaultData.sevenDayAvg;
    this.formData["cell_35"].resultValue = this.defaultData.twentyEightDayAvg;
    this.formData["cell_36"].resultValue = this.defaultData.referenceMobility;
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 7d活性指数
      if (this.hasValues([26, 34])) {
        val = Math.round((this.getFieldVal(26) / this.getFieldVal(34)) * 100);
      }
      this.setFieldVal(37, val);
      val = "";
      // 21d活性指数
      if (this.hasValues([33, 35])) {
        val = Math.round((this.getFieldVal(33) / this.getFieldVal(35)) * 100);
      }
      this.setFieldVal(38, val);
      val = "";
      // 流动度
      if (this.hasValues([36, 39])) {
        val = Math.round((this.getFieldVal(39) / this.getFieldVal(36)) * 100);
      }
      this.setFieldVal(42, val);
      // 计算平均值
      //7d抗压
      this.calcAverage([20, 21, 22, 23, 24, 25], 26);
      //28d抗压
      this.calcAverage([27, 28, 29, 30, 31, 32], 33);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(2);
      }
      this.setFieldVal(z, res);
    },

    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      console.log(config.form);
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_40":
          if (this.hasValues(form, ["40_p01", "40_p02", "40_p03"])) {
            res = ((this.getFieldVal("40_p01", false, form) / (this.getFieldVal("40_p03", false, form) - this.getFieldVal("40_p02", false, form))) * 100).toFixed(2);
          }
          this.setFieldVal("40_p04", res);
          break;
        case "cell_43":
          if (this.hasValues(form, ["43_p01", "43_p02", "43_p03"])) {
            res = (((this.getFieldVal("43_p03", false, form) - this.getFieldVal("43_p01", false, form)) / this.getFieldVal("43_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("43_p04", res);
          break;
        case "cell_44":
          if (this.hasValues(form, ["44_p01", "44_p02", "44_p03"])) {
            res = (((this.getFieldVal("44_p01", false, form) + this.getFieldVal("44_p02", false, form) - this.getFieldVal("44_p03", false, form)) / this.getFieldVal("44_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("44_p04", res);
          break;
        case "cell_46":
          if (this.hasValues(form, ["46_p01", "46_p02", "46_p03"])) {
            res = (((this.getFieldVal("46_p01", false, form) - this.getFieldVal("46_p02", false, form)) / (this.getFieldVal("46_p01", false, form) * this.getFieldVal("46_p03", false, form))) * 0.8865).toFixed(2);
          }
          this.setFieldVal("46_p04", res);
          break;
        case "cell_47":
          if (this.hasValues(form, ["47_p01", "47_p02"])) {
            res = (((this.getFieldVal("47_p01", false, form) - this.getFieldVal("47_p02", false, form)) / this.getFieldVal("47_p01", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("47_p03", res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
.red { // 配置项颜色
    color: red;
    cursor: pointer;
}
.red-bg {
    background: red;
    color: #000;
}
</style>
